<!--
 * @Autor: 
 * @Description: 新品卡片
 * @Date: 2021-07-16 16:16:18
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: 2021-07-23 16:11:12
-->
<template>
  <div class="new-good-card"  @click="toDetail">
    <div class="img-box">
      <img :src="itemData.categoryTabItemImg" class="item-img" :class="{'big': itemData.mallImgType == 1}">
      <div v-if="isInWarmUp && itemData.stock === 0" class="no-stock">
        <img src="https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/no-stock.png" />
      </div>
    </div>
    <div class="item-container">
      <div class="item-name">
        <img v-if="itemData.saleBillionPlus" src="https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/hot-good.png"/>{{itemData.recommend}}
      </div>
      <div class="item-sub-title">{{itemData.itemName}}</div>
      <!-- <div class="tag-list">
        <span v-for="(item, index) in itemData.markArray" :key="index" v-show="item.type !== 7 && item.type !== 6">
          <img class="label-img" :src="item.img" v-if="item.type == 11 && item.img" >
          <span v-else class="tag-style text-x" :class="`tag-style-${item.type}`" :style='{"color":item.colour}'>
            {{item.name}}
          </span>
        </span>
      </div> -->
      <div class="mark-wrap">
        <markText :showAtmosphere="true" :markList="itemData.markArray"></markText>
      </div>
      <div class="bottom_wrap">
        <div class="price_box">
          <span class="pb_fx">￥</span>
          <span class="pb_num">{{itemData.itemPrice}}</span>
          <span v-if="!showCommission" class="price-vip">￥{{itemData.itemVipPrice}}</span>
          <span class="pb_xh" v-if="showCommission">/</span>
          <span class="pb_num2" v-if="showCommission">赚{{itemData.minCommission}}</span>
        </div>
        <div class="by_btn">立即购买</div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import YunJi from '@/assets/js/YunJi'
import markText from '@/pages/commodity/components/Marking'

const { mapState } = createNamespacedHelpers('categoryNav')

export default {
  name: 'new-good-card',
  components: {
    markText
  },
  props: {
    itemData: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      appCont: Number(YunJi.getUrlParams('appCont') || 0)
    }
  },
  computed: {
    ...mapState(['userType', 'isSharing']),
    showCommission() {
      return (this.appCont == 1 && !this.isSharing) || (this.appCont == 7 && this.userType == 1)
    },
    // 是否在预热期
    isInWarmUp() {
      const currentTime = new Date().getTime()
      return currentTime < this.itemData.startTime
    },
    // tag过滤石榴节标签，并且只显示2个
    tagList() {
      const arr = []
      arr.push({ type: 2, text: '新品' })
      if (this.itemData.sellTextForBC) arr.push({ type: 8, text: this.itemData.sellTextForBC })
      return arr
    },
    // 按钮背景
    priceBtnBg() {
      if (this.itemData.stock === 0) return 'background-image: url(https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/new-good-price-btn-3.png);'
      if (this.isInWarmUp) return 'background-image: url(https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/new-good-price-btn-2.png);'
      return 'background-image: url(https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/new-good-price-btn.png);'
    },
    // 按钮文案颜色
    btnTextColor() {
      if (this.isInWarmUp || this.itemData.stock === 0) return 'color: #666666;'
      return 'color: #EE2532;'
    }
  },
  methods: {
    tagText() {
      if (this.itemData.sellTextForBC) return this.itemData.sellTextForBC
      const currentTime = new Date().getTime()
      if (currentTime < this.itemData.startTime) return '查看详情'
      return '立即抢购'
    },
    toDetail() {
      this.$emit('toDetail', {
        clickType: '主推新品',
        index: this.index,
        jumpType: 2, // 0无跳转 1专题 2商品 3网址 4品牌团 5直播 6主播 7榜单 8店铺编码
        jumpValue: this.itemData.itemId
      })
    }
  }
}
</script>
<style lang="less" scoped>
.new-good-card {
  // height: 2.06rem;
  position: relative;
  // margin-left: .08rem;
  border-radius: .08rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .img-box {
    box-sizing: border-box;
    position: relative;
    background-color: #FCFCFC;
    width: 100%;
    line-height: 0;
    .item-img {
      height: 2.2rem;
      width: 100%;
      border-radius: .08rem .08rem 0 0;
      box-sizing: border-box;
      &.big {
        height: 4.38rem;
      }
    }
    .left-top-tag {
      position: absolute;
      left: .12rem;
      top: .12rem;
      width: .68rem;
      height: .68rem;
      font-family: PingFangSC-Medium;
      font-size: .24rem;
      color: #FFFFFF;
      background-color: #EE2532;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
    .bottom-tag {
      opacity: 0.6;
      background-color: #000000;
      font-family: PingFangSC-Regular;
      font-size: .24rem;
      color: #FFFFFF;
      text-align: center;
      line-height: .32rem;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
    .no-stock {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0,0,0,0.20);
      box-sizing: border-box;
      border-radius: .08rem .08rem 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 1.02rem;
        height: 1.02rem;
        z-index: 10;
      }
    }
  }
  .item-container {
    position: relative;
    flex: 1;
    box-sizing: border-box;
    padding: .16rem .12rem .1rem;
  }
  .item-name {
    // width: 2.96rem;
    word-break: break-all;
    font-family: PingFangSC-Medium;
    font-size: .26rem;
    color: #262626;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    margin-bottom: .06rem;
    img {
      width: 1rem;
      height: .32rem;
      float: left;
      margin-right: .1rem;
    }
  }
  .item-sub-title {
    font-family: PingFangSC-Regular;
    font-size: .22rem;
    margin-bottom: .08rem;
    color: #999999;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .tag-list {
    overflow: hidden;
    height: .36rem;
    margin-bottom: .14rem;
    display: flex;
    align-items: center;
    .label-img{
      display: inline-block;
      height: .3rem;
      background-size: 100% 100%;
      vertical-align: initial;
      margin-right: .08rem;
      position: relative;
      top: -1px;
    }
  }
  .tag-style {
    border-radius: .04rem;
    font-size: .24rem;
    display: inline-flex;
    transform: scale(.9);
    text-size-adjust: none;
    padding: 0 .06rem;
    line-height: .36rem;
    max-width: 2.35rem;
  }
  .tag-style:nth-child(n + 2) {
    // margin-left: -.05rem
  }
  .tag-style-2 {
    font-family: PingFangSC-Regular;
    background: #FF2735;
    color: #FFFFFF;
    
  }
  .tag-style-8 {
    background: rgba(238,37,50,0.10);
    color: #EE2532;
  }
  .mark-wrap {
    margin-bottom: .16rem;
  }
  .bottom_wrap{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .price_box{
      font-size: .24rem;
      .pb_fx{
        color: #FF2735;
      }
      .pb_num{
        font-family: DINAlternate-Bold;
        font-size: .4rem;
        color: #FF2735;
        transform: translateY(1px);
        display: inline-block;
      }
      .price-vip {
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #999999;
        transform: scale(.8);
        text-size-adjust: none;
        display: inline-block;
        text-decoration:line-through;
      }
      .pb_xh{
        margin: 0 .08rem;
      }
      .pb_num2{
        font-size: .22rem;
        color: #262626;
      }
    }
    .by_btn{
      background-image: linear-gradient(108deg, #F93F55 3%, #EE2532 90%);
      border-radius: .24rem;
      width: 1.38rem;
      height: .44rem;
      line-height: .44rem;
      text-align: center;
      font-size: .22rem;
      color: #fff;
      font-family: PingFangSC-Semibold;
      transform: translateY(-.06rem);
    }
  }
  .price-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    // width: 2.96rem;
    height: .72rem;
    display: flex;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .price-box {
      width: 1.5rem;
      height: 100%;
      display: flex;
      padding-left: .12rem;
      justify-content: center;
      flex-direction: column;
      .price-value {
        margin-top: .06rem;
        font-family: DINAlternate-Bold;
        color: #fff;
        .label {font-size: .22rem}
        .value {font-size: .32rem}
      }
      .price-get {
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #FFFFFF;
        transform: scale(.8);
        display: inline-block;
        margin-left: -.12rem;
        margin-top: -.08rem;
      }
      .price-vip {
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #FFFFFF;
        transform: scale(.8);
        display: inline-block;
        text-decoration:line-through;
        margin-left: -.14rem;
        margin-top: -.08rem;
      }
    }
    .item-tag {
      width: 1.2rem;
      font-size: .22rem;
      padding-top: .02rem;
      color: #EE2532;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .has-second {
      padding-top: .04rem !important;
    }
  }
}
</style>
